// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { baseGridHiddenProps, baseGridProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block/Block";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { gridGapStyles, stretchStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";
/* Store Custom Code - End */

export interface SideColumnLayoutProps extends ExpandStyles<SideColumnLayoutStyles> {
    id: string;
    showSideColumnOnMobile?: boolean;
}

export interface SideColumnLayoutStyles {
    container?: GridContainerProps;
    leftColumn?: GridItemProps;
    rightColumn?: GridItemProps;
    // Store Custom Code
    block?: BlockProps;
    spacerGridItem?: GridItemProps;
}

export const sideColumnLayoutStyles: SideColumnLayoutStyles = {
    /* Store Custom Code - Start */
    block: {
        stretch: true,
    },
    container: {
        gap: 0,
        css: css`
            ${stretchStyles()}
            ${x => gridGapStyles(["10px", null, null, "30px"], x.theme.design.layout.spacing.content)}
        `,
    },
    leftColumn: {
        width: [0, 0, 0, 3, 3],
    },
    rightColumn: {
        width: [12, 12, 12, 8, 8],
        printWidth: 12,
    },
    spacerGridItem: {
        width: [0, 0, 0, 1, 1],
        css: css`
            &::before {
                content: "";
                display: block;
                position: relative;
                left: 40%;
                width: 1px;
                background: ${getColor("common.border")};

                ${({ theme }) => css`
                    ${breakpointValues(
                        theme.design.layout.spacing.content.map(x => `calc(100% + ${x} * 2)`),
                        "height",
                    )}
                    ${breakpointValues(
                        theme.design.layout.spacing.content.map(x => `-${x}`),
                        "top",
                    )}
                `}
            }
        `,
    },
    /* Store Custom Code - End */
};

const SideColumnLayout: FC<SideColumnLayoutProps> = ({
    id,
    extendedStyles,
    overridedStyles,
    showSideColumnOnMobile,
}) => {
    const baseStyles = useMemo(() => {
        const gridProps = showSideColumnOnMobile ? baseGridProps : baseGridHiddenProps;
        return mergeProps<SideColumnLayoutStyles>(sideColumnLayoutStyles, {
            container: gridProps.container,
            leftColumn: gridProps.sideColumn,
            rightColumn: gridProps.mainColumn,
        });
    }, [sideColumnLayoutStyles, showSideColumnOnMobile]);
    const styles = useExpandProps(sideColumnLayoutStyles, extendedStyles, overridedStyles); // Store Custom Code

    return (
        <Block {...styles.block} /* Store Custom Code */>
            <GridContainer {...styles.container}>
                <GridItem {...styles.leftColumn}>
                    <Zone contentId={id} zoneName="Side" />
                </GridItem>
                {/* Store Custom Code - Start */}
                <GridItem {...styles.spacerGridItem} />
                {/* Store Custom Code - End */}
                <GridItem {...styles.rightColumn}>
                    <Zone contentId={id} zoneName="Content" />
                </GridItem>
            </GridContainer>
        </Block>
    );
};

export default SideColumnLayout;
